
import Lottie from "lottie-web";

export function blockLottie() {
    document.querySelectorAll('.lottie-block').forEach((container) => {
        const player = container.querySelector(".lottie-player");

            let image_id = (player.dataset.id) ? player.dataset.id : false;


        if(!image_id) return false;

        let    path = player.dataset.path,
            file = ajax_object.site_url + '?lottie=' + image_id;


        let lottie = new Lottie.loadAnimation({
            container: player,
            renderer: 'svg',
            loop : false,
            autoplay: true,
            path: file,
            assetsPath : ajax_object.upload + '/' + path + '/'
        })
    })
}